<template>
    <el-card class="main-card">
        <div slot="header" style="display: flex; align-items: center; justify-content: space-between">
            <span style="font-size: 18px; font-weight: bold">模板产品型号</span>
            <div style="display: flex; align-items: center; gap: 8px">
                <el-input size="mini" v-model="searchKeyword" placeholder="请输入模板名称" clearable
                    style="width: 200px" @clear="handleSearch" @keyup.enter.native="handleSearch" />
                <el-button size="mini" type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
                <el-button size="mini" type="primary" icon="el-icon-plus" @click="openAddDialog">新增模板</el-button>
            </div>
        </div>

        <el-table :data="tableData" border stripe v-loading="loading" style="width: 100%"
            :row-style="{ cursor: 'pointer' }" @row-click="handleRowClick">
            <el-table-column type="index" label="序号" width="60" align="center" />
            <el-table-column prop="templateName" label="模板名称" min-width="140" />
            <el-table-column label="产品图片" width="90" align="center">
                <template slot-scope="scope">
                    <el-image v-if="scope.row.productModel && scope.row.productModel.urlHttp"
                        :src="formatImage(scope.row.productModel.urlHttp)" fit="cover"
                        style="width: 50px; height: 50px; border-radius: 4px"
                        :preview-src-list="[formatImage(scope.row.productModel.urlHttp)]"
                        @click.stop />
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="关联产品型号" min-width="150">
                <template slot-scope="scope">
                    <div v-if="scope.row.productModel">
                        <div>{{ scope.row.productModel.name }}</div>
                        <div style="color: #9ca3af; font-size: 12px">{{ scope.row.productModel.code }}</div>
                    </div>
                    <span v-else>--</span>
                </template>
            </el-table-column>
            <el-table-column label="型号描述" min-width="200" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ (scope.row.productModel && scope.row.productModel.description) || '--' }}
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{ scope.row.remark || '--' }}
                </template>
            </el-table-column>
            <el-table-column prop="createdTime" label="创建时间" width="160" align="center" />
            <el-table-column label="更新时间" width="160" align="center">
                <template slot-scope="scope">
                    {{ scope.row.updatedTime || '--' }}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" style="color: #000"
                        @click.stop="handleRowClick(scope.row)">详情</el-button>
                    <el-button size="mini" type="text" @click.stop="openEditDialog(scope.row)">编辑</el-button>
                    <el-button size="mini" type="text" style="color: #f56c6c"
                        @click.stop="handleDelete(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" background class="pagination" />
        </div>

        <!-- 新增/编辑模板弹窗 -->
        <el-dialog :title="editId ? '编辑模板产品型号' : '新增模板产品型号'" :visible.sync="addVisible" width="760px" margin-top="10vh"
            :close-on-click-modal="false" custom-class="add-template-dialog" @closed="resetAddForm">
            <el-form ref="addFormRef" :model="addForm" :rules="addRules" label-width="110px">
                <el-form-item label="模板名称" prop="templateName">
                    <el-input v-model="addForm.templateName" placeholder="请输入模板名称" maxlength="50" show-word-limit
                        clearable />
                </el-form-item>
                <el-form-item label="关联产品型号" prop="modelId">
                    <el-select v-model="addForm.modelId" placeholder="请选择产品型号" style="width: 100%"
                        @visible-change="visible => visible && fetchModelOptions()">
                        <el-option v-if="modelLoading" :key="'loading'" value="" label="加载中..." disabled />
                        <el-option v-for="item in modelOptions" :key="item.id" :value="item.id"
                            :label="item.name">
                            <div style="display: flex; align-items: center; justify-content: space-between">
                                <span>{{ item.name }}</span>
                                <span style="color: #9ca3af; font-size: 12px">{{ item.code }}</span>
                            </div>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input v-model="addForm.remark" type="textarea" :rows="2" placeholder="请输入备注"
                        maxlength="200" show-word-limit />
                </el-form-item>
                <el-form-item label="排序" prop="sortOrder">
                    <el-input-number v-model="addForm.sortOrder" :min="0" :max="9999" controls-position="right" />
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-switch v-model="addForm.status" :active-value="1" :inactive-value="0"
                        active-text="激活" inactive-text="停用" />
                </el-form-item>

                <!-- 产品尺寸（仅编辑时展示） -->
                <el-form-item v-if="editId" label="产品尺寸" prop="sizeIds">
                    <el-select v-model="addForm.sizeIds" multiple collapse-tags placeholder="请选择尺寸（可多选）"
                        style="width: 100%" @visible-change="visible => visible && fetchSizeOptions()">
                        <el-option v-if="sizeLoading" :key="'loading'" value="" label="加载中..." disabled />
                        <el-option v-for="item in sizeOptions" :key="item.id" :value="item.id" :label="item.name">
                            <span>{{ item.name }}</span>
                            <span style="color: #9ca3af; font-size: 12px; margin-left: 8px">{{ item.code }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>

                <!-- 配置项（仅编辑时展示） -->
                <el-form-item v-if="editId" label="配置项">
                    <div v-if="addForm.templateProductItemList.length" class="item-row item-row-header">
                        <span style="width: 150px">配置分组</span>
                        <span style="width: 150px">配置子项</span>
                        <span style="width: 90px">默认数量</span>
                        <span style="width: 90px">最小数量</span>
                        <span style="width: 90px">最大数量</span>
                        <span style="width: 30px"></span>
                    </div>
                    <div v-for="(row, index) in addForm.templateProductItemList" :key="index" class="item-row">
                        <el-select v-model="row.groupId" placeholder="选择分组" size="small" style="width: 150px"
                            @visible-change="visible => visible && fetchGroupOptions()"
                            @change="handleItemGroupChange(row)">
                            <el-option v-if="groupLoading" :key="'loading'" value="" label="加载中..." disabled />
                            <el-option v-for="g in groupOptions" :key="g.groupId" :value="g.groupId"
                                :label="g.name || g.groupId" />
                        </el-select>
                        <el-select v-model="row.itemId" placeholder="选择子项" size="small" style="width: 150px"
                            :disabled="!row.groupId"
                            @visible-change="visible => visible && fetchRowItemOptions(row)">
                            <el-option v-if="itemLoading" :key="'loading'" value="" label="加载中..." disabled />
                            <el-option v-for="it in getRowItemOptions(row.groupId)" :key="it.itemId"
                                :value="it.itemId" :label="it.itemName || it.itemId" />
                        </el-select>
                        <el-input-number v-model="row.defaultQty" :min="1" :max="9999" size="small"
                            controls-position="right" style="width: 90px" />
                        <el-input-number v-model="row.minQty" :min="0" :max="9999" size="small"
                            controls-position="right" style="width: 90px" />
                        <el-input-number v-model="row.maxQty" :min="1" :max="9999" size="small"
                            controls-position="right" style="width: 90px" />
                        <el-button type="text" icon="el-icon-delete" class="item-row-del"
                            @click="removeItemRow(index)" />
                    </div>
                    <el-button type="text" icon="el-icon-plus" @click="addItemRow">添加配置项</el-button>
                </el-form-item>
            </el-form>
            <div slot="footer" style="display: flex; justify-content: flex-end; gap: 6px">
                <el-button @click="addVisible = false">取消</el-button>
                <el-button type="primary" :loading="addLoading" @click="handleSaveSubmit">保存</el-button>
            </div>
        </el-dialog>
    </el-card>
</template>

<script>
import {
    templateProductModelApi,
    productModelList,
    productSizeList,
    configGroupList,
    configItemList
} from '@/api/quote'
import { formatImage } from '@/utils/format'

export default {
    name: 'TemplateProductModel',
    data() {
        return {
            searchKeyword: '',
            loading: false,
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            // 新增/编辑弹窗
            addVisible: false,
            addLoading: false,
            editId: null, // 有值表示编辑模式
            modelOptions: [],
            sizeOptions: [],
            groupOptions: [],
            modelLoading: false,
            sizeLoading: false,
            groupLoading: false,
            itemLoading: false,
            itemOptionsCache: {}, // 配置子项缓存：groupId -> items
            editSizeMap: {}, // 编辑时原始尺寸行：sizeId -> row（更新时带回 id/templateId）
            addForm: {
                templateName: '',
                modelId: null,
                remark: '',
                sortOrder: 0,
                status: 1,
                sizeIds: [],
                templateProductItemList: [],
            },
            addRules: {
                templateName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }],
                modelId: [{ required: true, message: '请选择产品型号', trigger: 'change' }],
            },
        }
    },
    mounted() {
        this.fetchList();
    },
    methods: {
        formatImage,
        // 获取模板产品型号列表
        async fetchList() {
            this.loading = true;
            try {
                const params = {
                    current: this.currentPage,
                    size: this.pageSize,
                    filter: [],
                    sorted: [],
                }
                if (this.searchKeyword) {
                    params.filter.push({
                        name: 'templateName',
                        type: 'LIKE',
                        value: this.searchKeyword
                    })
                }

                const res = await templateProductModelApi.page(params)
                if (res && res.code === '0000') {
                    this.tableData = res.result.records || [];
                    this.total = res.result.total || 0;
                }
            } catch (error) {
                console.error('获取模板产品型号列表失败：', error)
                this.tableData = [];
            } finally {
                this.loading = false;
            }
        },

        // 点击行进入详情
        handleRowClick(row) {
            this.$router.push({
                path: `/templateProductModel/detail/${row.id}`
            })
        },

        // 打开新增弹窗
        openAddDialog() {
            this.addVisible = true;
        },

        // 打开编辑弹窗：先拉详情回填（列表数据里尺寸/配置项为 null）
        async openEditDialog(row) {
            try {
                const res = await templateProductModelApi.detail(row.id)
                if (!res || res.code !== '0000') return;
                const detail = res.result || {}
                this.editId = detail.id;
                this.addForm = {
                    templateName: detail.templateName || '',
                    modelId: detail.modelId || null,
                    remark: detail.remark || '',
                    sortOrder: detail.sortOrder || 0,
                    status: detail.status !== undefined && detail.status !== null ? detail.status : 1,
                    sizeIds: (detail.templateProductSizeList || []).map(s => s.sizeId),
                    templateProductItemList: [],
                };
                // 缓存原始尺寸行，更新提交时带回 id/templateId/status
                this.editSizeMap = {};
                (detail.templateProductSizeList || []).forEach(s => {
                    this.editSizeMap[s.sizeId] = s;
                });
                // 拍平各分组下的配置项为表单行（保留子行 id，更新时需要）
                const rows = [];
                (detail.templateProductGroupList || []).forEach(group => {
                    (group.templateProductItemList || []).forEach(item => {
                        rows.push({
                            id: item.id,
                            templateId: item.templateId,
                            status: item.status,
                            groupId: item.groupId || group.groupId,
                            itemId: item.itemId !== undefined && item.itemId !== null
                                ? item.itemId
                                : (item.configItem ? item.configItem.id : item.id),
                            defaultQty: item.defaultQty !== undefined && item.defaultQty !== null ? item.defaultQty : 1,
                            minQty: item.minQty !== undefined && item.minQty !== null ? item.minQty : 1,
                            maxQty: item.maxQty !== undefined && item.maxQty !== null ? item.maxQty : 3,
                            groupOrder: item.groupOrder || 0,
                            itemOrder: item.itemOrder || 0,
                        });
                    });
                });
                this.addForm.templateProductItemList = rows;
                // 预载各分组的配置子项选项
                this.addVisible = true;
            } catch (error) {
                console.error('获取模板详情失败：', error)
            }
        },

        // 获取产品型号下拉选项
        async fetchModelOptions() {
            if (this.modelOptions.length) return; // 已加载过则复用，避免每次展开下拉重复请求
            this.modelLoading = true;
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 100,
                }
                const res = await productModelList(param)
                if (res && res.code === '0000') {
                    this.modelOptions = res.result.records || []
                }
            } catch (error) {
                console.error('获取产品型号选项失败：', error)
            } finally {
                this.modelLoading = false;
            }
        },

        // 获取产品尺寸下拉选项
        async fetchSizeOptions() {
            if (this.sizeOptions.length) return; // 已加载过则复用，避免每次展开下拉重复请求
            this.sizeLoading = true;
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 200,
                }
                const res = await productSizeList(param)
                if (res && res.code === '0000') {
                    this.sizeOptions = res.result.records || []
                }
            } catch (error) {
                console.error('获取产品尺寸选项失败：', error)
            } finally {
                this.sizeLoading = false;
            }
        },

        // 获取配置分组下拉选项
        async fetchGroupOptions() {
            if (this.groupOptions.length) return; // 已加载过则复用，避免每次展开下拉重复请求
            this.groupLoading = true;
            try {
                const param = {
                    filter: [],
                    sorted: [],
                    current: 0,
                    size: 200,
                }
                const res = await configGroupList(param)
                if (res && res.code === '0000') {
                    this.groupOptions = res.result.records || []
                }
            } catch (error) {
                console.error('获取配置分组选项失败：', error)
            } finally {
                this.groupLoading = false;
            }
        },

        // 配置项行：切换分组，清空子项并加载该分组下的子项
        handleItemGroupChange(row) {
            row.itemId = null; // 切换分组只清空子项，子项在点击下拉时按当前分组加载
        },

        // 点击子项下拉时，按该行的当前分组加载子项选项
        fetchRowItemOptions(row) {
            this.fetchItemOptions(row.groupId);
        },

        // 按分组加载配置子项（带缓存）
        async fetchItemOptions(groupId) {
            if (!groupId || this.itemOptionsCache[groupId]) return;
            this.itemLoading = true;
            try {
                const param = {
                    filter: [{ name: 'groupId', type: 'EQ', value: groupId }],
                    sorted: [],
                    current: 0,
                    size: 200,
                }
                const res = await configItemList(param)
                if (res && res.code === '0000') {
                    this.$set(this.itemOptionsCache, groupId, res.result.records || [])
                }
            } catch (error) {
                console.error('获取配置子项选项失败：', error)
            } finally {
                this.itemLoading = false;
            }
        },

        // 获取某行的配置子项选项
        getRowItemOptions(groupId) {
            return this.itemOptionsCache[groupId] || []
        },

        // 添加配置项行
        addItemRow() {
            this.addForm.templateProductItemList.push({
                groupId: null,
                itemId: null,
                defaultQty: 1,
                minQty: 1,
                maxQty: 3,
                groupOrder: 0,
                itemOrder: 0,
            });
        },

        // 删除配置项行
        removeItemRow(index) {
            this.addForm.templateProductItemList.splice(index, 1);
        },

        // 重置新增/编辑表单
        resetAddForm() {
            this.editId = null;
            this.editSizeMap = {};
            this.addForm = {
                templateName: '',
                modelId: null,
                remark: '',
                sortOrder: 0,
                status: 1,
                sizeIds: [],
                templateProductItemList: [],
            };
            this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
        },

        // 提交保存（新增/编辑）
        handleSaveSubmit() {
            this.$refs.addFormRef.validate(async (valid) => {
                if (!valid) return;
                // 校验配置项行完整性
                for (const row of this.addForm.templateProductItemList) {
                    if (!row.groupId || !row.itemId) {
                        this.$message.warning('请完整选择每个配置项的分组和子项')
                        return;
                    }
                }
                this.addLoading = true;
                try {
                    const param = {
                        templateName: this.addForm.templateName,
                        modelId: this.addForm.modelId,
                        remark: this.addForm.remark,
                        sortOrder: this.addForm.sortOrder,
                        status: this.addForm.status,
                        templateProductSizeList: this.addForm.sizeIds.map((sizeId, index) => {
                            // 编辑模式下已有尺寸行带回 id/templateId/status（新增时 editSizeMap 为空，字段为 undefined 不会序列化）
                            const origin = this.editSizeMap[sizeId] || {}
                            return {
                                id: origin.id,
                                templateId: origin.templateId,
                                status: origin.status,
                                sizeId,
                                remark: origin.remark || '',
                                sortOrder: index,
                            }
                        }),
                        templateProductItemList: this.addForm.templateProductItemList,
                    }
                    const res = this.editId
                        ? await templateProductModelApi.update({ id: this.editId, ...param })
                        : await templateProductModelApi.add(param)
                    if (res && res.code === '0000') {
                        this.$message.success(this.editId ? '更新成功' : '新增成功')
                        this.addVisible = false;
                        this.fetchList();
                    } else {
                        this.$message.error(res.message || (this.editId ? '更新失败' : '新增失败'))
                    }
                } catch (error) {
                    console.error('保存模板产品型号失败：', error)
                } finally {
                    this.addLoading = false;
                }
            });
        },

        // 删除模板
        handleDelete(row) {
            this.$confirm(`此操作将永久删除模板【${row.templateName}】, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await templateProductModelApi.delete(row.id)
                    if (res && res.code === '0000') {
                        this.$message.success('删除成功')
                        // 删除后如果当前页已空且不是第一页，回退一页
                        if (this.tableData.length === 1 && this.currentPage > 1) {
                            this.currentPage -= 1;
                        }
                        this.fetchList();
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除模板产品型号失败：', error)
                }
            }).catch(() => {});
        },

        // 搜索
        handleSearch() {
            this.currentPage = 1;
            this.fetchList();
        },

        handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            this.fetchList();
        },

        handleCurrentChange(val) {
            this.currentPage = val;
            this.fetchList();
        },
    }
}
</script>

<style scoped>
.main-card {
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border: none;
}

.pagination-container {
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
}

/* 配置项动态行 */
.item-row {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
}

.item-row-header {
    font-size: 12px;
    color: #909399;
    margin-bottom: 4px;
}

.item-row-header span {
    flex-shrink: 0;
}

.item-row-del {
    color: #f56c6c;
    font-size: 16px;
    width: 30px;
}

/* 弹窗内容过高时滚动 */
::v-deep .add-template-dialog .el-dialog__body {
    max-height: 62vh;
    overflow-y: auto;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1890ff;
}
</style>
